module.exports = __webpack_public_path__ + "img/login3.70d74358.png";